import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveModel: ['model', 'onSuccess', 'onError'],
  removeModel: ['model', 'onSuccess', 'onError'],
  modelError: ['error']
})

const saveModel = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeModel = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const modelError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.MODEL_ERROR]: modelError,

  [Types.SAVE_MODEL]: saveModel,
  [Types.REMOVE_MODEL]: removeModel,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ModelTypes,
  Creators as ModelActions
}
